import type { ICommunePayload } from '@/modules/cart/domain/AddressCommune';
import type { Cart } from '@/modules/cart/domain/Cart';
import type { CartRepository } from '@/modules/cart/domain/CartRepository';

const saveShippingAddressCommune = (
  repository: CartRepository,
  commune: ICommunePayload
): Promise<Cart> => {
  return repository.saveShippingAddressCommune(commune);
};

export default saveShippingAddressCommune;
